import React from 'react';

export default function MainLayout({ children }) {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
                minHeight: '100vh',
            }}
        >
            {/* <main> */}
            <div style={{ flexGrow: 1 }}>{children}</div>
            {/* </main> */}
        </div>
    );
}
